/* GRAFFITI — Shopify theme behaviour
   No libraries. Everything degrades gracefully without JS: the bag falls
   back to the /cart page and every add button is a real form submit.

   Two rules keep this alive inside Shopify, where the static preview had it
   easy. Nothing is cached in a variable at load — the customizer swaps whole
   sections in and out, so a cached node goes stale the moment a merchant
   edits something. And nothing assumes an element exists — a section that is
   only on the home page must not throw on a product page and take the rest
   of the script down with it. */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* ── money ───────────────────────────────────────────────────
     Shopify has SIX money-format placeholders, not four. Norwegian kroner
     use {{amount_with_space_separator}}, which this did not implement -- so
     with NOK active the cart printed the placeholder as literal text.

     Liquid's `money` filter was always fine; only the JS-rendered prices
     (cart drawer, variant switching, shop-the-look) were broken. Defined
     once here because the same logic living in two places is exactly how
     half of it got missed. */
  function groupBy(s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }

  function formatMoney(cents, fmt) {
    fmt = fmt || '${{amount}}';
    var v = (Math.round(cents) / 100).toFixed(2).split('.');
    var whole = v[0], dec = v[1];
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, groupBy(whole, ',') + '.' + dec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, groupBy(whole, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, groupBy(whole, '.') + ',' + dec)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, groupBy(whole, '.'))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, groupBy(whole, "'") + '.' + dec)
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, groupBy(whole, ' '))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, groupBy(whole, ' ') + ',' + dec);
  }

  // whatever format Shopify is currently presenting in -- with Markets local
  // currencies on, this is the active currency's format, not the shop's base
  function moneyFormat() {
    var bag = document.getElementById('bag');
    return (bag && bag.dataset.moneyFormat) || '${{amount}}';
  }


  var byId = function (id) { return document.getElementById(id); };

  /* ── sticky header ───────────────────────────────────────── */
  // over the dark hero video the header reverses out; past it, it picks up
  // the paper backdrop instead. Never both at once.
  var headH = 0;
  var pinAt = null;      // scroll offset at which the bar reaches the top

  function onScrollHead() {
    var head = byId('head');
    if (!head) return;

    // measured once per layout, not per scroll: reading offsetHeight here on
    // every frame is both a forced reflow and, when the bar's own height was
    // animating, a threshold that moved as the class it decides toggled
    if (!headH) headH = head.offsetHeight;

    // the point where the bar reaches the top of the screen: everything in
    // flow above it. Measured once per layout, never per frame.
    if (pinAt === null) {
      var wrap = head.closest ? head.closest('.header-sticky') : null;
      pinAt = wrap ? Math.round(wrap.getBoundingClientRect().top + window.scrollY) : 0;
    }
    head.classList.toggle('is-fixed', window.scrollY >= pinAt);

    var hero = byId('top');
    var overHero = false;
    if (hero) {
      overHero = hero.getBoundingClientRect().bottom > headH + 8;
    }
    head.classList.toggle('is-over', overHero);
    var stuck = !overHero && window.scrollY > 12;
    head.classList.toggle('is-stuck', stuck);
  }

  /* ── mobile nav ──────────────────────────────────────────── */
  function setMenu(open) {
    var burger = byId('burger');
    var mobnav = byId('mobnav');
    var head = byId('head');
    if (!burger || !mobnav) return;

    burger.setAttribute('aria-expanded', String(open));
    mobnav.classList.toggle('open', open);
    mobnav.setAttribute('aria-hidden', String(!open));
    if (head) head.classList.toggle('is-menu', open);
    document.body.classList.toggle('is-locked', open);
  }

  /* ── reveal on scroll, staggered per group ───────────────── */
  var io = null;
  if (!reduced && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('in');
        io.unobserve(en.target);
      });
      // a fixed inset, not a percentage — percentages behave badly on very
      // tall or very short viewports and can leave whole sections unrevealed
    }, { rootMargin: '0px 0px -70px 0px', threshold: 0.05 });
  }

  function setupReveals(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.reveal'));
    if (!io) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var seen = new Map();
    items.forEach(function (el) {
      var i = seen.get(el.parentNode) || 0;
      seen.set(el.parentNode, i + 1);
      if (i) el.style.transitionDelay = Math.min(i * 70, 420) + 'ms';
      io.observe(el);
    });
  }

  /* ── parallax (very light touch) ─────────────────────────── */
  var layers = [];
  var ticking = false;

  // A phone gets no parallax. paint() reads a bounding rect per layer per
  // frame, which forces a synchronous layout mid-scroll -- affordable on a
  // desktop, and the difference between smooth and juddering on a phone.
  var wide = window.matchMedia('(min-width: 861px)');

  function collectLayers() {
    layers = wide.matches
      ? Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'))
      : [];
  }

  function paint() {
    ticking = false;
    var vh = window.innerHeight;
    layers.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var speed = parseFloat(el.dataset.parallax) || 0;
      el.style.translate = '0 ' + ((r.top + r.height / 2 - vh / 2) * -speed).toFixed(1) + 'px';
    });
  }

  // iOS fires scroll events far faster than it paints. Coalescing to one
  // frame keeps the header's own class toggle off the critical path.
  var queued = false;

  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      onScrollHead();
      if (!reduced && layers.length && !ticking) { ticking = true; requestAnimationFrame(paint); }
    });
  }

  /* ── hero video ──────────────────────────────────────────
     Muted autoplay is usually allowed, but low-power modes and some
     mobile browsers still block it — retry, and fall back to the first
     tap. Pause it while off-screen so it isn't decoding for nothing. */
  function setupVideo(root) {
    var vid = root.querySelector('.hero__vid');
    if (!vid) return;

    var play = function () {
      var p = vid.play();
      if (p && p.catch) p.catch(function () { /* poster frame stands in */ });
    };
    play();
    document.addEventListener('pointerdown', play, { once: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? play() : vid.pause(); });
      }, { threshold: 0.15 }).observe(vid);
    }
  }

  /* ── the piece flying to the bag ────────────────────
     A clone of whatever picture was clicked, animated from where it sits to
     the cart button. It is position:fixed and pointer-events:none, so it can
     never push the page around, and it removes itself when it lands. */
  function flyToCart(origin) {
    if (reduced || !origin || !origin.animate) return;

    var img = origin.matches('img') ? origin : origin.querySelector('img');
    var cart = byId('cartBtn');
    if (!img || !cart || !img.currentSrc && !img.src) return;

    var from = img.getBoundingClientRect();
    var to = cart.getBoundingClientRect();
    if (!from.width || !to.width) return;

    var chip = document.createElement('img');
    chip.src = img.currentSrc || img.src;
    chip.className = 'fly';
    chip.alt = '';
    chip.setAttribute('aria-hidden', 'true');
    chip.style.left = from.left + 'px';
    chip.style.top = from.top + 'px';
    chip.style.width = from.width + 'px';
    chip.style.height = from.height + 'px';
    document.body.appendChild(chip);

    // land on the middle of the cart button, shrunk to a chip
    var end = 46;
    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);
    var scale = end / Math.max(from.width, from.height);

    var run = chip.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.35 - 70) + 'px) scale(' +
          (scale + (1 - scale) * 0.45) + ') rotate(-9deg)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + scale + ') rotate(6deg)',
        opacity: 0.15 },
    ], { duration: 760, easing: 'cubic-bezier(.55,.06,.3,1)' });

    run.onfinish = run.oncancel = function () { chip.remove(); };
  }

  /* ── shoppable tags on the tagged posts ──────────────────── */
  function setupTags(root) {
    // flip a card inward when its dot sits near an edge of the photo
    Array.prototype.forEach.call(root.querySelectorAll('.tag'), function (tag) {
      var x = parseFloat(tag.style.getPropertyValue('--x'));
      var y = parseFloat(tag.style.getPropertyValue('--y'));
      if (x < 28) tag.classList.add('tag--l');
      else if (x > 72) tag.classList.add('tag--r');
      // dots in the upper half open downwards, so the card stays inside the
      // photo instead of sliding up under the sticky header
      if (y < 45) tag.classList.add('tag--low');
    });
  }

  function closeTags(except) {
    // queried fresh rather than held in an array, so a section the merchant
    // just edited is still handled
    Array.prototype.forEach.call(document.querySelectorAll('.tag.is-open'), function (t) {
      if (t === except) return;
      t.classList.remove('is-open');
      var d = t.querySelector('.tag__dot');
      if (d) d.setAttribute('aria-expanded', 'false');
    });
  }

  /* ── join the list ────────────────────────────────
     The markup is a real Shopify customer form and still works untouched with
     JavaScript off. What it does badly is answer: the native post reloads the
     page, and the reply lands far below the fold, so it reads as if nothing
     happened. This posts the same form in the background and replies in place.

     Success is detected from the URL Shopify redirects to rather than by
     scraping the returned HTML for a phrase, which would break the moment the
     wording changed. Anything unexpected falls back to a real submit, so the
     worst case is the old behaviour rather than a lost signup. */
  function setupJoin(root) {
    var form = root.querySelector ? root.querySelector('.join__signup') : null;
    if (!form || form.dataset.joinBound) return;
    form.dataset.joinBound = '1';

    var msg = form.querySelector('[data-join-msg]');
    var go = form.querySelector('[data-join-go]');
    var field = form.querySelector('input[type="email"]');

    function say(text, ok) {
      if (!msg) return;
      msg.textContent = text;
      msg.classList.toggle('join__msg--ok', !!ok);
      msg.classList.toggle('join__msg--bad', !ok);
    }

    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;      // let it post normally
      if (!field || !field.value.trim()) return;
      e.preventDefault();

      var label = go ? go.textContent : '';
      if (go) { go.disabled = true; go.textContent = '…'; }
      say('', true);
      msg && msg.classList.remove('join__msg--ok', 'join__msg--bad');

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
      })
        .then(function (r) {
          // Shopify sends you to ?customer_posted=true when it took the address
          if (r.url && r.url.indexOf('customer_posted=true') !== -1) {
            say(form.dataset.ok || 'You are on the list.', true);
            field.value = '';
            field.disabled = true;
            if (go) go.textContent = label;
            return;
          }
          return r.text().then(function (html) {
            // the reply came back without the success flag: read Shopify's own
            // error out of the returned page so the wording stays theirs
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var err = doc.querySelector('.join__msg--bad, .errors, .form__message--error');
            say((err && err.textContent.trim()) || 'That address did not go through.', false);
            if (go) { go.disabled = false; go.textContent = label; }
          });
        })
        .catch(function () {
          // offline, or the request was blocked: hand it back to the browser
          if (go) { go.disabled = false; go.textContent = label; }
          form.submit();
        });
    });
  }

  /* ── the product page ──────────────────────────────
     Options are radio pills rather than a select, so picking a size is one
     tap. Changing one repoints the hidden id the form posts, updates the
     price and the button, strikes through combinations that are gone, and
     swaps to that variant's photo. Without JS the pills are still real radios
     inside a real form, and Shopify resolves the variant server-side. */
  function setupProduct(root) {
    var section = root.querySelector ? (root.querySelector('.pdp') ||
                  (root.classList && root.classList.contains('pdp') ? root : null)) : null;
    if (!section || section.dataset.pdpBound) return;
    section.dataset.pdpBound = '1';

    var data = section.querySelector('#pdpVariants');
    var variants = [];
    if (data) {
      try { variants = JSON.parse(data.textContent); } catch (err) { variants = []; }
    }

    var hidden = section.querySelector('#pdpVariant');
    var addBtn = section.querySelector('#pdpAdd');
    var label = addBtn && addBtn.querySelector('[data-add-label]');
    var priceBox = section.querySelector('#pdpPrice');
    var stage = section.querySelector('#pdpStage');

    function chosen() {
      return Array.prototype.map.call(
        section.querySelectorAll('.pdp__pill-in:checked'),
        function (r) { return r.value; });
    }

    function money(cents) { return formatMoney(cents, moneyFormat()); }

    function showMedia(id) {
      if (!stage || !id) return;
      var frame = stage.querySelector('[data-media="' + id + '"]');
      if (!frame) return;
      Array.prototype.forEach.call(stage.querySelectorAll('.pdp__frame'), function (f) {
        f.classList.toggle('is-on', f === frame);
      });
      Array.prototype.forEach.call(section.querySelectorAll('.pdp__thumb'), function (t) {
        t.classList.toggle('is-on', t.dataset.thumb === String(id));
      });
    }

    function sync() {
      var picked = chosen();
      if (!picked.length || !variants.length) return;

      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], same = true;
        for (var j = 0; j < picked.length; j++) {
          if (v.options[j] !== picked[j]) { same = false; break; }
        }
        if (same) { match = v; break; }
      }

      // strike through any value that cannot be bought alongside the rest
      Array.prototype.forEach.call(section.querySelectorAll('.pdp__pill-in'), function (radio) {
        var idx = Number(radio.dataset.index) - 1;
        var test = picked.slice();
        test[idx] = radio.value;
        var live = variants.some(function (v) {
          return v.available && test.every(function (val, k) { return v.options[k] === val; });
        });
        if (live) radio.removeAttribute('data-gone');
        else radio.setAttribute('data-gone', '');
      });

      Array.prototype.forEach.call(section.querySelectorAll('[data-picked]'), function (out) {
        var idx = Number(out.dataset.picked) - 1;
        if (picked[idx]) out.textContent = picked[idx];
      });

      if (!match) {
        if (addBtn) addBtn.disabled = true;
        if (label) label.textContent = 'Unavailable';
        return;
      }

      if (hidden) hidden.value = match.id;
      if (addBtn) addBtn.disabled = !match.available;
      if (label) label.textContent = match.available ? 'Add to bag' : 'Sold out';

      if (priceBox) {
        var html = '<span class="price">' + money(match.price);
        if (match.compare > match.price) {
          html += '<s class="price__was">' + money(match.compare) + '</s>';
        }
        priceBox.innerHTML = html + '</span>';
      }

      if (match.media) showMedia(match.media);

      // keep the address bar on the variant, so a shared link opens on it
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', match.id);
        history.replaceState({}, '', u);
      }
    }

    section.addEventListener('change', function (e) {
      if (e.target.classList.contains('pdp__pill-in')) sync();
    });
    sync();

    Array.prototype.forEach.call(section.querySelectorAll('.pdp__thumb'), function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.thumb); });
    });

    /* the zoom. Click to hold it on, and while it is on the cursor drives the
       transform origin so you can travel around the print. Pointer-based, so
       it simply never engages on a touch screen. */
    if (stage && window.matchMedia('(hover:hover)').matches) {
      stage.addEventListener('click', function () {
        stage.classList.toggle('is-zoom');
      });
      stage.addEventListener('mousemove', function (e) {
        if (!stage.classList.contains('is-zoom')) return;
        var r = stage.getBoundingClientRect();
        stage.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
        stage.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
      stage.addEventListener('mouseleave', function () {
        stage.classList.remove('is-zoom');
      });
    }
  }

  /* ── drag the Shop the look row ──────────────────────────── */
  function setupStrip(root) {
    var strip = root.id === 'posts' ? root : root.querySelector('#posts');
    if (!strip || !window.PointerEvent || strip.dataset.dragBound) return;
    strip.dataset.dragBound = '1';

    var dragging = false, startX = 0, startLeft = 0, travelled = 0, pid = null;
    var justDragged = false;

    strip.addEventListener('pointerdown', function (e) {
      justDragged = false;
      if (e.button !== 0) return;
      if (e.target.closest('.tag')) return;      // leave the shoppable dots alone
      dragging = true; travelled = 0; pid = e.pointerId;
      startX = e.clientX; startLeft = strip.scrollLeft;
      strip.setPointerCapture(pid);
      strip.classList.add('is-dragging');
    });

    strip.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > travelled) travelled = Math.abs(dx);
      strip.scrollLeft = startLeft - dx;
    });

    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (type) {
      strip.addEventListener(type, function () {
        if (!dragging) return;
        dragging = false;
        justDragged = travelled > 6;
        // only the click this gesture generates is suppressed; if none comes,
        // stop holding the flag so nothing later gets swallowed
        if (justDragged) setTimeout(function () { justDragged = false; }, 400);
        strip.classList.remove('is-dragging');
        if (pid !== null && strip.hasPointerCapture && strip.hasPointerCapture(pid)) {
          strip.releasePointerCapture(pid);
        }
        pid = null;
      });
    });

    // a drag that ends on a link must not also follow it — but only that one
    // click, so a later tap (or a keyboard Enter, which fires no pointer
    // events at all) still gets through
    strip.addEventListener('click', function (e) {
      if (justDragged) { e.preventDefault(); e.stopPropagation(); }
      justDragged = false;
    }, true);
  }

  /* ── document-level listeners, bound exactly once ─────────── */
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    headH = 0;                       // let it be measured again at this width
    collectLayers();                 // parallax comes and goes with the width
    onScroll();
  });

  // delegated, so a section the customizer replaces never leaves a dead
  // listener behind or needs rebinding
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.tag__dot');
    if (dot) {
      var tag = dot.closest('.tag');
      var open = !tag.classList.contains('is-open');
      closeTags(tag);
      tag.classList.toggle('is-open', open);
      dot.setAttribute('aria-expanded', String(open));
      return;
    }
    if (!e.target.closest('.tag')) closeTags(null);

    if (e.target.closest('#burger')) {
      setMenu(byId('burger').getAttribute('aria-expanded') !== 'true');
    } else if (e.target.closest('#mobnav a')) {
      setMenu(false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeTags(null);

    var drawer = byId('bag');
    var mobnav = byId('mobnav');
    if (drawer && !drawer.hidden) {
      var close = byId('bagClose');
      if (close) close.click();
    } else if (mobnav && mobnav.classList.contains('open')) {
      setMenu(false);
    }
  });

  /* ── bag ─────────────────────────────────────────────────────
     Talks to Shopify's cart API, so the drawer, the header count and
     the /cart page never disagree. */
  var bag = byId('bag');

  if (bag) {
    var bagList = byId('bagList');
    var bagEmpty = byId('bagEmpty');
    var bagTotal = byId('bagTotal');
    var bagClose = byId('bagClose');
    var bagScrim = byId('bagScrim');
    var lastFocus = null;

    var ROUTES = {
      cart: bag.dataset.cartUrl || '/cart',
      add: bag.dataset.addUrl || '/cart/add',
      change: bag.dataset.changeUrl || '/cart/change'
    };
    var FORMAT = bag.dataset.moneyFormat || '${{amount}}';

    function money(cents) { return formatMoney(cents, FORMAT); }

    function post(url, body) {
      return fetch(url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }

    function change(key, quantity) {
      return post(ROUTES.change, { id: key, quantity: quantity }).then(render);
    }

    function render(cart) {
      // the count lives in the header section, which the customizer can
      // replace under us — look it up per render
      var cartN = byId('cartN');
      if (cartN) cartN.textContent = String(cart.item_count);
      if (bagTotal) bagTotal.textContent = money(cart.total_price);
      if (bagEmpty) bagEmpty.hidden = cart.items.length > 0;
      paintSaving(cart);
      if (!bagList) return;
      bagList.innerHTML = '';

      cart.items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'bag__row';
        li.innerHTML =
          (item.image ? '<img alt="">' : '<span></span>') +
          '<div><p class="bag__name"></p><p class="bag__variant"></p><p class="bag__price"></p>' +
            '<span class="bag__qty">' +
              '<button type="button" data-step="-1" aria-label="One fewer">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-step="1" aria-label="One more">+</button>' +
            '</span></div>' +
          '<button type="button" class="bag__drop" data-drop>Remove</button>';

        if (item.image) li.querySelector('img').src = item.image;
        li.querySelector('.bag__name').textContent = item.product_title;

        var vt = li.querySelector('.bag__variant');
        if (item.variant_title && item.variant_title.indexOf('Default') === -1) {
          vt.textContent = item.variant_title;
        } else {
          vt.remove();
        }
        li.querySelector('.bag__price').textContent = money(item.final_line_price);

        li.querySelectorAll('[data-step]').forEach(function (b) {
          b.addEventListener('click', function () {
            change(item.key, item.quantity + Number(b.dataset.step));
          });
        });
        li.querySelector('[data-drop]').addEventListener('click', function () {
          change(item.key, 0);
        });
        bagList.appendChild(li);
      });
    }

    /* A code reached through /discount/CODE is taken off the cart straight
       away -- cart.total_discount already carries it -- but nothing on the
       page said so, which is exactly the doubt that loses people at
       checkout. Show the saving where the money is. */
    function readCookie(name) {
      var parts = document.cookie ? document.cookie.split('; ') : [];
      for (var i = 0; i < parts.length; i++) {
        var eq = parts[i].indexOf('=');
        if (eq > 0 && parts[i].slice(0, eq) === name) {
          try { return decodeURIComponent(parts[i].slice(eq + 1)); }
          catch (err) { return parts[i].slice(eq + 1); }
        }
      }
      return '';
    }

    function discountCode(cart) {
      var codes = cart && cart.discount_codes;
      if (codes) {
        for (var i = 0; i < codes.length; i++) {
          if (codes[i].applicable && codes[i].code) return codes[i].code;
        }
      }
      var apps = cart && cart.cart_level_discount_applications;
      if (apps && apps.length && apps[0].title) return apps[0].title;
      return '';
    }

    function paintSaving(cart) {
      var row = byId('bagSave');
      var saved = cart.total_discount || 0;
      if (row) {
        row.hidden = saved <= 0;
        if (saved > 0) {
          var amt = byId('bagSaveAmt');
          var chip = byId('bagCode');
          if (amt) amt.textContent = '−' + money(saved);
          if (chip) {
            var code = discountCode(cart);
            chip.textContent = code;
            chip.hidden = !code;
          }
        }
      }

      // the price before the code came off, kept next to the one they pay
      var was = byId('bagWas');
      if (was) {
        was.hidden = saved <= 0;
        if (saved > 0) was.textContent = money(cart.original_total_price);
      }

      // an empty cart has no discount to report, so fall back to the cookie
      var note = byId('bagWaiting');
      if (!note) return;
      var held = cart.items.length === 0 ? readCookie('discount_code') : '';
      note.hidden = !held;
      var slot = byId('bagWaitCode');
      if (held && slot) slot.textContent = held;
    }

    function refresh() {
      return fetch(ROUTES.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () { /* offline: the server-rendered count still stands */ });
    }

    function openBag() {
      var cartBtn = byId('cartBtn');
      lastFocus = document.activeElement;
      bag.hidden = false;
      setTimeout(function () { bag.classList.add('is-open'); }, 20);
      if (cartBtn) cartBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('is-locked');
      if (bagClose) bagClose.focus();
    }

    function closeBag() {
      var cartBtn = byId('cartBtn');
      bag.classList.remove('is-open');
      if (cartBtn) cartBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('is-locked');
      setTimeout(function () { bag.hidden = true; }, 420);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (bagClose) bagClose.addEventListener('click', closeBag);
    if (bagScrim) bagScrim.addEventListener('click', closeBag);

    // delegated too — the cart button is inside the header section
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#cartBtn')) return;
      if (bag.classList.contains('is-open')) { closeBag(); } else { openBag(); }
    });

    bag.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = bag.querySelectorAll('button, a[href], input');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // the product page form goes through the same drawer
    var pdpForm = byId('add-to-cart');
    if (pdpForm) {
      pdpForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = Number(new FormData(pdpForm).get('id'));
        if (!id) return;

        var go = pdpForm.querySelector('[data-add-label]');
        var was = go ? go.textContent : '';
        if (go) { go.textContent = 'Added'; }
        pdpForm.querySelector('.pdp__add').classList.add('done');

        flyToCart(document.querySelector('.pdp__frame.is-on img'));

        var cartN = byId('cartN');
        if (cartN) {
          cartN.classList.add('pop');
          setTimeout(function () { cartN.classList.remove('pop'); }, 320);
        }

        post(ROUTES.add, { items: [{ id: id, quantity: 1 }] })
          .then(refresh)
          .then(openBag)
          .then(function () {
            setTimeout(function () {
              if (go) go.textContent = was;
              pdpForm.querySelector('.pdp__add').classList.remove('done');
            }, 1400);
          });
      });
    }

    refresh();
  }

  /* ── spray paint ──────────────────────────────────────────
     Hold and drag on the paper and it sprays; let go and press again for a
     new colour. One canvas behind everything inside .shell, which is why the
     paint never covers type: the dark sections draw their own backgrounds on
     top of it, so it only ever shows through on the paper.

     Mouse only. On a phone a drag is how you scroll, and a canvas that ate
     that gesture would make the site unusable. */
  function setupSpray() {
    if (document.body.classList.contains('no-spray')) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;

    var shell = document.querySelector('.shell');
    if (!shell || shell.querySelector('.spray')) return;

    var cv = document.createElement('canvas');
    cv.className = 'spray';
    cv.setAttribute('aria-hidden', 'true');
    shell.appendChild(cv);
    var ctx = cv.getContext('2d');

    // the four category inks, plus two that only turn up here
    var COLOURS = ['#2246c8', '#e0301a', '#f26a1b', '#7aba18', '#8a4fd8', '#e8b81e'];
    var colour = COLOURS[0];
    var lastColour = -1;

    // pressing anything you could click, drag or type into is not a spray
    var KEEP_OFF = 'a, button, input, textarea, select, summary, label,' +
                   '.posts, .pdp__stage, .bag, .mobnav, .tag, .fold__row';

    function resize() {
      var w = shell.clientWidth;
      var h = shell.scrollHeight;
      if (!w || !h) return;
      if (cv.width === w && cv.height === h) return;

      // keep whatever is already sprayed across a resize
      var keep = null;
      if (cv.width && cv.height) {
        keep = document.createElement('canvas');
        keep.width = cv.width;
        keep.height = cv.height;
        keep.getContext('2d').drawImage(cv, 0, 0);
      }
      cv.width = w;
      cv.height = h;
      cv.style.width = w + 'px';
      cv.style.height = h + 'px';
      if (keep) ctx.drawImage(keep, 0, 0);
    }

    resize();
    window.addEventListener('resize', function () { remeasureHead(); onScrollHead(); });
  window.addEventListener('resize', resize);
    // sections open and close and the page gets taller; keep the canvas with it
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(shell);

    /* One puff of aerosol: dots scattered in a disc, thickest in the middle
       and fading out, which is what makes it read as spray rather than ink. */
    function puff(x, y) {
      var r = 24;
      ctx.fillStyle = colour;
      for (var i = 0; i < 26; i++) {
        var a = Math.random() * Math.PI * 2;
        var d = Math.pow(Math.random(), 0.55) * r;
        ctx.globalAlpha = (1 - d / r) * 0.22 + 0.02;
        ctx.beginPath();
        ctx.arc(x + Math.cos(a) * d, y + Math.sin(a) * d,
                Math.random() * 1.5 + 0.35, 0, 6.2832);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
    }

    var down = false, live = false, px = 0, py = 0, sx = 0, sy = 0;

    function at(e) {
      var box = cv.getBoundingClientRect();
      return { x: e.clientX - box.left, y: e.clientY - box.top };
    }

    document.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || e.pointerType !== 'mouse') return;
      if (e.target.closest(KEEP_OFF)) return;

      down = true;
      live = false;
      var p = at(e);
      px = sx = p.x;
      py = sy = p.y;

      // a new can every time you press, never the same one twice running
      var pick = Math.floor(Math.random() * COLOURS.length);
      if (pick === lastColour) pick = (pick + 1) % COLOURS.length;
      lastColour = pick;
      colour = COLOURS[pick];
    });

    document.addEventListener('pointermove', function (e) {
      if (!down) return;
      var p = at(e);

      // a plain click leaves nothing behind; it has to travel first
      if (!live) {
        if (Math.abs(p.x - sx) + Math.abs(p.y - sy) < 5) return;
        live = true;
        document.body.classList.add('is-spraying');
      }

      // step along the path so a fast drag still lays a continuous line
      var dx = p.x - px, dy = p.y - py;
      var steps = Math.max(1, Math.ceil(Math.sqrt(dx * dx + dy * dy) / 5));
      for (var i = 1; i <= steps; i++) puff(px + dx * i / steps, py + dy * i / steps);
      px = p.x;
      py = p.y;
    });

    function up() {
      down = false;
      live = false;
      document.body.classList.remove('is-spraying');
    }
    document.addEventListener('pointerup', up);
    document.addEventListener('pointercancel', up);
    window.addEventListener('blur', up);
  }

  /* ── start, and start again for the customizer ───────────── */
  // The newsletter form is a real Shopify customer form; it posts on its own
  // and deliberately has no script attached to it.
  /* ── lift the menu out of the sticky header ──────────────────
     The fullscreen menu is markup of the header section, so Liquid has no
     way to render it anywhere else -- its links, collections and doodles all
     come from that section's settings. But while it sits inside the sticky
     wrapper we cannot give that wrapper its own compositor layer: a
     transform would become the containing block for a position:fixed child,
     and the menu would size itself to the 51px bar instead of the screen.

     So move it at runtime, into .shell rather than <body>. .shell isolates
     its stacking context; a menu parked outside it would paint over the
     header and cover its own burger, which is a bug this theme has had once
     already. Inside .shell the old z-index order (menu 90, header 100)
     still holds.

     The promotion itself is applied by the class this adds, never by CSS
     alone -- if this never runs, nothing is promoted and the menu keeps
     working exactly as before. */
  function remeasureHead() { headH = 0; pinAt = null; }

  /* The strip of phone above and below the page is deliberately NOT painted
     from here any more.

     It used to be swung to paper while the bar was white and back to black
     afterwards. Measured on the real page, scroll 0 on load and scroll 0
     after scrolling down and back are identical in every respect -- same
     classes, same position, same backgrounds, same theme-color -- and yet
     iOS 26 kept the strip light for the rest of the page view. It latches
     onto the light value and never lets go; only a reload clears it.

     Since the page cannot make it let go, the fix is to never hand it a
     light value at all. theme-color is now the static black in theme.liquid
     and nothing rewrites it, so there is only ever one colour to latch. */


  /* ── language / country ──────────────────────────────────────
     Two separate jobs, one code path for actually switching.

     The footer picker is server-rendered and works without any of this: each
     select ships with a submit button. All this does is hide those buttons
     and submit on change, turning two taps into one.

     The bar is the "looks like you're in Norway" offer. It is deliberately an
     offer and not a redirect -- Shopify's own guidance is that auto-
     redirecting on IP breaks page caching and SEO (crawlers come from the US
     with no Accept-Language) and strands anyone on a VPN. */
  function setupLocalePicker() {
    var pick = byId('locpick');
    if (!pick) return;
    // the editor rebuilds the footer on every edit; without this the change
    // listener would be added again each time and submit the form twice
    if (pick.dataset.ready) return;
    pick.dataset.ready = '1';
    pick.querySelectorAll('.locpick__go').forEach(function (b) { b.hidden = true; });
    pick.querySelectorAll('.locpick__sel').forEach(function (sel) {
      sel.addEventListener('change', function () {
        if (sel.form) sel.form.submit();
      });
    });
  }

  var SUGGEST_KEY = 'graffiti:locale-dismissed';

  function setupLocaleSuggest() {
    var bar = byId('locsug');
    if (!bar || !window.Shopify || !window.Shopify.routes) return;

    // asked once; saying no should stick
    try {
      if (localStorage.getItem(SUGGEST_KEY)) return;
    } catch (e) { /* private mode: just ask again */ }

    var here = window.Shopify;

    // Shopify exposes the active locale as .locale; there is no .language,
    // so excluding on that name sent an empty exclude and the endpoint
    // happily suggested the language we were already reading.
    var curLang = String(here.locale || document.documentElement.lang || '')
                    .toLowerCase().split('-')[0];
    var curCountry = String(here.country || '').toUpperCase();

    var url = here.routes.root + 'browsing_context_suggestions.json'
      + '?country[enabled]=true&country[exclude]=' + encodeURIComponent(curCountry)
      + '&language[enabled]=true&language[exclude]=' + encodeURIComponent(curLang);

    fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.suggestions || !data.suggestions.length) return;
        var parts = data.suggestions[0].parts || {};
        var lang = parts.language;
        var country = parts.country;

        // Belt and braces: never offer what is already on screen. The
        // exclude params above should cover it, but a suggestion matching
        // the current context is worse than no bar at all -- that is how
        // "Looks like you're in English" ended up on an English page.
        if (lang && String(lang.handle).toLowerCase().split('-')[0] === curLang) lang = null;
        if (country && String(country.handle).toUpperCase() === curCountry) country = null;
        if (!lang && !country) return;

        // The endpoint names things in the language being suggested, so the
        // offer already reads in that language. Both sentences come from the
        // locale file with a %% where the name goes, rather than being glued
        // together here -- word order is not the same in every language.
        // A country and a language need different sentences. "Looks like
        // you're in Norway" is right for a place; for a language with no
        // country it has to be "This store is also in Norwegian", because
        // nobody is standing in a language.
        var tpl = country ? bar.dataset.tplPlace : bar.dataset.tplLang;
        var place = country ? country.name : lang.name;
        var label = lang ? lang.name : country.name;
        var txt = byId('locsug-txt');
        var go = byId('locsug-go');
        if (txt) txt.textContent = (tpl || '%%').replace('%%', place);
        if (go) go.textContent = (bar.dataset.tplSwitch || '%%').replace('%%', label);

        if (lang) byId('locsug-lang').value = lang.handle;
        if (country) byId('locsug-country').value = country.handle;

        // an empty hidden input would post a blank and clear the setting
        ['locsug-lang', 'locsug-country'].forEach(function (id) {
          var el = byId(id);
          if (el && !el.value) el.disabled = true;
        });

        bar.hidden = false;
        requestAnimationFrame(function () { bar.classList.add('in'); });
      })
      .catch(function () { /* no suggestion is a fine outcome */ });

    var no = byId('locsug-no');
    if (no) {
      no.addEventListener('click', function () {
        bar.classList.remove('in');
        setTimeout(function () { bar.hidden = true; }, 300);
        try { localStorage.setItem(SUGGEST_KEY, '1'); } catch (e) {}
      });
    }
  }

  /* ── tidy the address bar ────────────────────────────────────
     Switching currency hops between graffiticlo.com and no.graffiticlo.com,
     which are separate hosts, so Shopify tags the landing URL with
     ?shpxid=... to carry the session across. By the time this runs the
     server has already read it -- it is spent, and only litters the bar.

     replaceState, deliberately, not location.reload(): a reload would flash
     the page, throw away the referrer, and cost a round trip to display a
     URL the browser is already showing. This rewrites history in place with
     no request at all. */
  function tidyUrl() {
    try {
      if (!window.history || !history.replaceState || !window.URL) return;
      var url = new URL(window.location.href);
      var spent = ['shpxid', '_ab', '_fd', '_sc'];
      var found = false;
      spent.forEach(function (k) {
        if (url.searchParams.has(k)) { url.searchParams.delete(k); found = true; }
      });
      if (!found) return;
      var qs = url.searchParams.toString();
      history.replaceState(history.state, '', url.pathname + (qs ? '?' + qs : '') + url.hash);
    } catch (e) { /* an untidy URL is not worth throwing over */ }
  }

  function hoistMenu() {
    var shell = document.querySelector('.shell');
    var wrap = document.querySelector('.header-sticky');
    if (!shell || !wrap) return;

    // the editor rebuilds the section, so a second copy can appear; the one
    // still inside the wrapper is the fresh one, any other is last round's
    var all = document.querySelectorAll('#mobnav');
    if (!all.length) return;
    var keep = all[0];
    for (var i = 1; i < all.length; i++) all[i].parentNode.removeChild(all[i]);

    if (keep.parentNode !== shell) shell.appendChild(keep);
  }

  /* ── the countdown on the coming-soon page ───────────────────
     Entirely optional decoration: no date, a date it cannot parse, or a date
     already gone and the row simply stays hidden and the page is unchanged.
     Safari will not parse "2026-09-01 18:00", so the space becomes a T. */
  function setupTick(root) {
    var el = root.querySelector ? root.querySelector('.cdown') : null;
    if (!el) return;

    var raw = (el.getAttribute('data-drop-at') || '').trim();
    if (!raw) return;
    var when = new Date(raw.replace(' ', 'T')).getTime();
    if (!when || isNaN(when)) return;

    var cell = {
      d: el.querySelector('[data-tick="d"]'), h: el.querySelector('[data-tick="h"]'),
      m: el.querySelector('[data-tick="m"]'), s: el.querySelector('[data-tick="s"]')
    };
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };

    function tick() {
      var left = when - Date.now();
      if (left <= 0) { el.hidden = true; return; }
      el.hidden = false;
      var secs = Math.floor(left / 1000);
      if (cell.d) cell.d.textContent = Math.floor(secs / 86400);
      if (cell.h) cell.h.textContent = pad(Math.floor(secs / 3600) % 24);
      if (cell.m) cell.m.textContent = pad(Math.floor(secs / 60) % 60);
      if (cell.s) cell.s.textContent = pad(secs % 60);
      setTimeout(tick, 1000);
    }
    tick();
  }

  // a wrong password must not stay folded away behind the link
  function openPwOnError(root) {
    var box = root.querySelector ? root.querySelector('.pw') : null;
    if (box && box.querySelector('.join__msg--bad')) box.open = true;
  }

  function boot(root) {
    setupTick(root);
    openPwOnError(root);
    setupReveals(root);
    setupVideo(root);
    setupTags(root);
    setupStrip(root);
    setupProduct(root);
    setupJoin(root);
  }

  boot(document);
  tidyUrl();
  hoistMenu();
  setupLocalePicker();
  setupLocaleSuggest();
  setupSpray();
  collectLayers();
  onScrollHead();
  if (!reduced) paint();

  // the theme editor tears a section down and rebuilds it on every edit
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
    hoistMenu();
    setupLocalePicker();
    collectLayers();
    onScrollHead();
    if (!reduced) paint();
  });
  document.addEventListener('shopify:section:unload', collectLayers);
})();
